<template>
  <el-dialog :visible.sync="visible" :title="'教师督导员设置'" :close-on-click-modal="false"
             :close-on-press-escape="false">
    <div class="mod-teacher-inspector__inspector">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.teacherName" placeholder="姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.phone" placeholder="用户名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle"
                style="width: 100%;">
        <el-table-column prop="teacherName"   label="姓名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="phone"   label="用户名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="teacherSex" label="性别" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.teacherSex === sexual.MAN">男</el-tag>
            <el-tag v-else-if="scope.row.teacherSex === sexual.WOMAN">女</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="schoolName" label="学校" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="isInArray(scope.row)" size="mini" @click="setInspector(scope.row)">选中</el-button>
            <el-button v-else=""  type="danger" size="mini" @click="removeInspector(scope.row)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="limit"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="pageSizeChangeHandle"
            @current-change="pageCurrentChangeHandle">
    </el-pagination>
    <template slot="footer">
      <el-button type="danger" @click="visible = false">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import debounce from 'lodash/debounce'
import { sexual, selected } from '@/constant'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/teacher/teacher/page',
        getDataListIsPage: true,
        createdIsNeed: false,
        activatedIsNeed: false
      },
      visible: false,
      inspectorList: [],
      sexual,
      selected,
      dataForm: {
        teacherName: '',
        phone: ''
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.getDataList()
        this.getDecorationInspectorList()
      })
    },
    getDecorationInspectorList () {
      this.$http.get('/decoration/decorationInspector/getList/').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.inspectorList = res.data
      }).catch(() => {
      })
    },
    isInArray (row) {
      for (var i = 0; i < this.inspectorList.length; i++) {
        if (row.userId === this.inspectorList[i].userId) {
          return false
        }
      }
      return true
    },
    removeInspector: debounce(function (row) {
      return this.$http.get(`/decoration/decorationInspector/removeInspector?userId=${row.userId}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.init()
        this.$emit('refreshDataList')
        this.$notify({
          type: 'info',
          duration: '750',
          message: '考核员移除成功'
        })
      })
    }, 50, { leading: true, trailing: false }),
    /**
       * 设置考核员员
       */
    setInspector: debounce(function (row) {
      // 组装参数
      const params = {
        userId: row.userId,
        userName: row.phone,
        realName: row.teacherName,
        sex: row.teacherSex,
        identity: 1,
        schoolId: row.schoolId
      }
      this.$http.post('/decoration/decorationInspector', params).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.init()
        this.$emit('refreshDataList')
        this.$notify({
          type: 'success',
          duration: '750',
          message: '考核设置成功'
        })
      })
    }, 50, { leading: true, trailing: false })
  }
}
</script>

<style scoped>

</style>
